import {RefObject} from "react"
import {
  ConsentListener,
  ConsentProvider,
  createConsentMap,
  createConsentStorage,
  readStoredConsentMap,
  updateStoredConsent
} from "@webng/liveblog";
import {fireTickarooLiveblogCustomConsent} from "../events";

const storage = createConsentStorage()

export class CustomConsentProvider implements ConsentProvider {
  private _listeners: ConsentListener[] = [];
  private _el: RefObject<HTMLDivElement> | null = null;
  private readonly _consentMap: Record<string, boolean | undefined> = createConsentMap()
  private readonly _useCookies: boolean = true;

  constructor(useCookies: boolean = true, el: RefObject<HTMLDivElement> | null) {
    this._useCookies = useCookies;
    this._el = el;
    if (useCookies) {
      this._consentMap = readStoredConsentMap(storage)
    }
  }

  getConsent(provider: string): boolean {
    return this._consentMap[provider] || false
  }

  requestConsent(provider: string, consent: boolean) {
    if (this._el && this._el.current && this._el.current.parentElement) {
      fireTickarooLiveblogCustomConsent(this._el.current.parentElement, { t: 'a_con', provider: provider, consent: consent })
    }
  }

  setConsent(provider: string, consent: boolean): void {
    this._consentMap[provider] = consent
    if (this._useCookies) {
      updateStoredConsent(storage, provider, consent)
    }
    this.fireConsentListener(provider, consent);
  }

  addConsentListener(listener: ConsentListener): void {
    this._listeners = [...this._listeners, listener];
  }

  removeConsentListener(listener: ConsentListener): void {
    this._listeners = this._listeners.filter(l => l !== listener)
  }

  protected fireConsentListener(provider: string, consent: boolean): void {
    this._listeners.forEach(value => value(provider, consent))
  }
}
